import React from 'react';

import PropTypes from 'prop-types';
import { getDisabledSignupStores } from 'staticStoreConfig';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { Login, SignUp } from './styled';

const LoggedOutControls = ({
    className,
    openSignUpFlow,
    openSignInFlow,
    isTransparent,
    storeCode,
    locationPathname,
}) => {
    const isSignUpButtonHidden = getDisabledSignupStores().includes(storeCode);
    const controlsHiddenForBlackFridaySignup = locationPathname.includes('black-friday-signup');
    if (controlsHiddenForBlackFridaySignup) {
        return null;
    }

    return (
        <div className={className}>
            <Login type="button" onClick={openSignInFlow} isTransparent={isTransparent}>
                <Translator tk="LOGGED_OUT_SIGN_IN" />
            </Login>
            {!isSignUpButtonHidden ? (
                <SignUp type="button" onClick={openSignUpFlow}>
                    <Translator tk="LOGGED_OUT_SIGN_UP" />
                </SignUp>
            ) : null}
        </div>
    );
};

LoggedOutControls.propTypes = {
    className: PropTypes.string,
    openSignUpFlow: PropTypes.func.isRequired,
    openSignInFlow: PropTypes.func.isRequired,
    storeCode: PropTypes.string,
};

LoggedOutControls.defaultProps = {
    className: '',
    storeCode: '',
};

export default LoggedOutControls;
